export const PlantDesignDrawingAndTechDetailsPage = {
  summary: {
    plantTypeLabel: 'Plant design:',
    subTypeLabel: 'Type:',
    manufacturerLabel: 'Manufacturer (if needed):',
    modelLabel: 'Model:',
    yearOfDesignLabel: 'Year of design or design alteration (if known)',
  },
  drawingList: {
    drawingListTitle: 'Drawings',
    drawingListHelpMessage: 'You can find the drawing details in the Designer and Design verifier statement',
    drawingDetailLabel: 'Drawing details',
    drawingTitleLabel: 'Drawing title',
    drawingNumberLabel: 'Drawing number',
    drawingRevisionNumberLabel: 'Revision number',
  },
  techStandardList: {
    techStandardListTitle: 'Technical standards',
    techStandardListHelpMessage: 'You can find technical standards in the Designer and Design verifier statement',
    techStandardLabel: 'Technical standard',
    techStandardNumberLabel: 'Technical standard number',
    yearOfPublicationLabel: 'Year of publication',
  },
  addDrawing: {
    drawingDetailsTitle: 'Drawing details',
    drawingDetailsHelpMessage:
      'The drawing details must match the representational drawing and Designer and Design verifier statement',
    titleLabel: 'Drawing title',
    numberLabel: 'Drawing number',
    revisionLabel: 'Revision number (if there is one)',
    revisionHelpMessage: 'A reference to the current version of the representational drawing',
    uploadedLabel: 'Uploaded drawing',
  },
  addTechStandard: {
    numberLabel: 'Technical standards number',
    numberHelpMessage: 'Include technical standard title and part where relevant',
    yearOfPublicationLabel: 'Year of publication',
  },
  engineeringPrinciples: {
    designComplianceLabel: 'Do all aspects of the design comply with these technical standards?',
    uploadFileHeader: 'Upload engineering principles',
    uploadFileDescription:
      'The designer must provide a separate document with the engineering principles used for the aspects of the design that do not comply with the technical standards.',
    uploadedFileLabel: 'Uploaded engineering principles',
  },
};
